const styles = theme => ({
  closeButton: {
    position: 'absolute',
    top: '20px',
    right: '10px',
  },
  closeButtonDraggable: {
    position: 'absolute',
    top: '21px',
    right: '10px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    width: '100%',
    padding: '6px 0px',
  },
  noticeHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: '100%',
    padding: '0px',
  },
  // These two were declared but never applied, which is why every modal title rendered as plain
  // body text, indistinguishable from the description right under it.
  titleStyle: {
    fontSize: '16px',
    fontWeight: 600,
    fontFamily: 'Inter',
  },
  titleStyleDraggable: {
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Inter',
  },
  noticeTitleStyle: {
    fontSize: '18px',
    fontWeight: 600,
    fontFamily: 'Inter',
    color: '#002E47',
    textAlign: 'center',
  },
})

export default styles
